import styled from "@emotion/styled";

import { fontSourceSerif4, theme } from "shared/lib/styles";

export const Container = styled.div`
  display: grid;
  grid-template-areas:
    "label"
    "primary-article-image-carousel"
    "primary-article"
    "secondary-articles";
  grid-template-columns: minmax(0, 1fr);
  gap: 16px;

  ${theme.breakpoints.up("tablet")} {
    grid-template-areas:
      "label label"
      "primary-article secondary-articles"
      "primary-article-image-carousel primary-article-image-carousel";
    grid-template-columns: minmax(0, 1fr) minmax(0, 340px);
    gap: 24px;

    padding-block: 0;
    border-block: none;
  }

  ${theme.breakpoints.up("desktop")} {
    grid-template-areas:
      "label label"
      "primary-article primary-article-image-carousel"
      "secondary-articles primary-article-image-carousel"
      "secondary-articles primary-article-image-carousel";
    grid-template-columns: minmax(0, 464px) minmax(592px, 1fr);
    gap: 16px 24px;
  }
`;

export const Label = styled.div`
  grid-area: label;

  display: flex;
  flex-direction: column;
  row-gap: 8px;

  color: #000000;
  font-weight: 400;
  font-size: 28px;
  font-family: ${fontSourceSerif4};
  line-height: 110%;
  letter-spacing: -4%;
  overflow-wrap: break-word;

  ${theme.breakpoints.up("tablet")} {
    font-size: 32px;
  }

  ${theme.breakpoints.up("desktop")} {
    font-size: 40px;
  }
`;

export const SecondaryArticles = styled.div`
  grid-area: secondary-articles;

  display: flex;
  flex-direction: column;
  row-gap: 12px;

  padding-block-start: 12px;
  border-block-start: 1px solid #dfdfdf;

  ${theme.breakpoints.up("tablet")} {
    row-gap: 16px;

    max-inline-size: 340px;
    padding-block-start: 0;
    padding-inline-start: 20px;
    border-block-start: none;
    border-inline-start: 1px solid #dfdfdf;
  }

  ${theme.breakpoints.up("desktop")} {
    max-inline-size: none;
    padding-block-start: 16px;
    padding-inline-start: 0;
    border-block-start: 1px solid #dfdfdf;
    border-inline-start: none;
  }

  > :last-child {
    flex-grow: 1;
  }

  > :not(:first-child) {
    padding-block-start: 12px;
    border-block-start: 1px solid #dfdfdf;

    ${theme.breakpoints.up("tablet")} {
      padding-block-start: 16px;
    }
  }
`;
